import { Reducers } from '@sda/enums/store';
import { PublicReviewMask } from '@sda/sdk/masks';
import { SDK } from './helpers/sdk';
import { SDKFactory } from './helpers/sdk.factory';
import type { FetchDataType, FirestoreClientData } from './interfaces';
import type { PrivateReview, PublicReview, Review } from '@sda/interfaces/review';

/**
 * SDK Class to interact with Firestore Reviews.
 */
export class Reviews extends SDK<PublicReview> {
  constructor(apiClient: FirestoreClientData) {
    super(apiClient, Reducers.REVIEWS);

    this.collection = this.fsh.Schema.PublicReviews;

    this.PublicMap = PublicReviewMask;
  }

  async getCombined(id: string): Promise<Review & FetchDataType> {
    return this.getCombinedRecord<PrivateReview>(
      id,
      this.Private().collection,
    );
  }

  Private(): SDK<PrivateReview> {
    return SDKFactory<PrivateReview>(this.fsh.clientData, this.fsh.Schema.PrivateReviews, { reducerName: Reducers.REVIEWS });
  }
}
